import { action, observable } from 'mobx';
import apiCaller from '../../utils/api-caller';

class CmsPaymentTypeStore {
  @observable data = [];
  @observable paymentTypeOptions = [];
  @observable paymentType = null;
  @observable paymentTypeId = null;

  @action getData() {
    return apiCaller.CmsPaymentTypes.get().then(resp => {
      if (!resp.isError) {
        if (resp.data) {
          this.data = resp.data;
        }
      }
    })
  }

  @action getOptions(defaultPaymentType) {
    const languageCode = window.localStorage.getItem('lang') || 'en';
    const noPostFlag = window.localStorage.getItem('noPostFlag') || false;
    return apiCaller.CmsPaymentTypes.getByLanguageCode(languageCode).then(resp => {
      if (resp) {
        if (resp.length > 0) {
          let options = [];

          defaultPaymentType && options.push({ label: defaultPaymentType, value: defaultPaymentType, })

          if (noPostFlag === 'true') {
            resp = resp.filter(fi => fi.noPost === true);
          }

          resp.map(item => {
            options.push({
              label: item.name,
              value: item.name,
              id: item.id
            });
            return item;
          });

          this.paymentTypeOptions = options;
          this.paymentType = options[0].value;
          this.paymentTypeId = options[0].id;
        } else {
          this.paymentTypeOptions = [];
          this.paymentType = null;
        }
      } else {
        this.paymentTypeOptions = [];
        this.paymentType = null;
      }
    })
  }

  @action initCreate(activeLanguages) {
    const getDataByIdZero = this.data.find(fi => fi.id === 0);
    if (!getDataByIdZero) {
      let newData = {
        'id': 0,
        'sort': 0,
        'noPost': false,
        'paymentTypeLanguages': []
      };

      activeLanguages.map(lang => {
        newData.paymentTypeLanguages.push({
          'id': 0,
          'paymentTypeId': 0,
          'languageId': lang.id,
          'name': ''
        });

        return lang;
      });

      this.data.push(newData);
    }
  }

  @action create() {
    const request = this.data.find(fi => fi.id === 0);
    return apiCaller.CmsPaymentTypes.create(request);
  }

  @action update(id) {
    const request = this.data.find(fi => fi.id === id);
    return apiCaller.CmsPaymentTypes.update(id, request);
  }

  @action delete(id) {
    return apiCaller.CmsPaymentTypes.delete(id);
  }

  @action cancel() {
    this.getData();
  }

  @action setnoPost(id, value) {
    let item = this.data.find(fi => fi.id === id);
    if (item) {
      item.noPost = value;
    }
  }

  @action setsort(id, value) {
    let item = this.data.find(fi => fi.id === id);
    if (item) {
      item.sort = value;
    }
  }

  @action setname(id, langId, value) {
    let item = this.data.find(fi => fi.id === id);
    if (item) {
      let lang = item.paymentTypeLanguages.find(fi => fi.languageId === langId);
      if (lang) {
        lang.name = value;
      }
    }
  }

  @action setpaymentType(value) {
    this.paymentType = value;
    // Find and set the corresponding ID
    const option = this.paymentTypeOptions.find(opt => opt.value === value);
    this.paymentTypeId = option ? option.id : null;
  }

  @action resetData() {
    this.paymentType = null;
    this.paymentTypeId = null;
    this.paymentTypeOptions = [];
  }
}

export default new CmsPaymentTypeStore();